module.exports = __webpack_public_path__ + "17df1127f5a02a167ac076d07eee2658.jpg";